import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import { THotsite, THotsiteConfiguration, THotsiteTerm } from '../entities/hotsite.model';

@Injectable({
  providedIn: 'root',
})
export class HotsiteService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public getHotsiteConfiguration(
    id: string
  ): Observable<THotsiteConfiguration> {
    return this.http.get<THotsiteConfiguration>(
      `${this.apiUrl.hotsite_service}/Settings`,
      {
        withCredentials: true,
        params: {
          id,
        },
      }
    );
  }

  public updateHotsiteConfiguration(
    data: THotsiteConfiguration
  ): Observable<THotsiteConfiguration> {
    return this.http.put<THotsiteConfiguration>(
      `${this.apiUrl.hotsite_service}/Settings`,
      data,
      { withCredentials: true }
    );
  }

  public getById(
    id: string
  ): Observable<THotsite> {
    return this.http.get<THotsite>(
      `${this.apiUrl.hotsite_service}/Hotsite`,
      {
        withCredentials: true,
        params: {
          id,
        },
      }
    );
  }

  public getTerm(
    id: string
  ): Observable<THotsiteTerm> {
    return this.http.get<THotsiteTerm>(
      `${this.apiUrl.hotsite_service}/term/GetById`,
      {
        withCredentials: true,
        params: {
          id,
        },
      }
    );
  }

  public deleteTerm(
    id: string
  ): Observable<any> {
    return this.http.delete<THotsiteTerm>(
      `${this.apiUrl.hotsite_service}/term`,
      {
        withCredentials: true,
        params: {
          id,
        },
      }
    );
  }

  public deleteHotsite(
    id: string
  ): Observable<any> {
    return this.http.delete<THotsite>(
      `${this.apiUrl.hotsite_service}/Hotsite`,
      {
        withCredentials: true,
        params: {
          id,
        },
      }
    );
  }

  public updateHotsite(
    data: THotsite
  ): Observable<THotsite> {
    return this.http.put<THotsite>(
      `${this.apiUrl.hotsite_service}/Hotsite`,
      data,
      { withCredentials: true }
    );
  }

  public updateTerm(
    data: THotsiteTerm
  ): Observable<THotsiteTerm> {
    return this.http.put<THotsiteTerm>(
      `${this.apiUrl.hotsite_service}/term`,
      data,
      { withCredentials: true }
    );
  }

  public createTerm(
    data: THotsiteTerm
  ): Observable<THotsiteTerm> {
    return this.http.post<THotsiteTerm>(
      `${this.apiUrl.hotsite_service}/term`,
      data,
      { withCredentials: true }
    );
  }

  public createHotsite(
    data: THotsite
  ): Observable<THotsite> {
    return this.http.post<THotsite>(
      `${this.apiUrl.hotsite_service}/Hotsite`,
      data,
      { withCredentials: true }
    );
  }
}
